"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowCrawling = allowCrawling;
function allowCrawling() {
    return process.env.VERCEL_ENV === "production";
}
